import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/kit";

export default function AuthCallback() {
  const { hash } = useLocation();
  const { googleExchange } = useAuth();
  const nav = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(hash.slice(1)).get("session_id");
    googleExchange(sessionId)
      .then((u) => nav(u?.has_paid ? "/" : "/paywall", { replace: true }))
      .catch((e) => {
        toast.error(errMsg(e, "Google sign-in failed"));
        nav("/login", { replace: true });
      });
  }, [hash, googleExchange, nav]);

  return <Spinner className="min-h-screen items-center" />;
}
